import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      title: '首页',
      notCache: true,
      icon: 'md-home',
      access: ['admin','Operation Management', 'operate video before', 'video manager']
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/audio_video_manage/video_data_views')
      }
    ]
  },
  {
    path: '/',
    name: '_event',
    meta: {
      access: ['admin'],
      hideInMenu: false,
      title: '事件记录',
      notCache: true,
      icon: 'md-pause'
    },
    component: Main,
    children: [
      {
        path: 'event',
        name: 'event',
        meta: {
          access: ['admin'],
          hideInMenu: false,
          title: '事件记录',
          notCache: true,
          icon: 'md-pause'
        },
        component: () => import('@/view/event/event')
      }
    ]
  },
  {
    path: '/',
    name: '_user',
    component: Main,
    meta: {
      access: ['admin', 'Operation Management', 'video manager'],
      hideInMenu: false,
      title: '帐号管理',
      notCache: true,
      icon: 'ios-people'
    },
    children: [
      {
        path: '/user',
        name: 'user',
        meta: {
          access: ['admin','Operation Management', 'video manager'],
          hideInMenu: false,
          title: '帐号管理',
          notCache: true,
          icon: 'ios-people'
        },
        component: () => import('@/view/user/user')
      }
    ]
  },
  {
    path: '/',
    name: '_role',
    component: Main,
    meta: {
      access: ['admin'],
      hideInMenu: false,
      title: '职位管理',
      notCache: true,
      icon: '_bear'
    },
    children: [
      {
        path: '/role',
        name: 'role',
        meta: {
          access: ['admin'],
          hideInMenu: false,
          title: '职位管理',
          notCache: true,
          icon: '_bear'
        },
        component: () => import('@/view/role/role')
      }
    ]
  },
  {
    path: '/',
    name: '_permission',
    component: Main,
    meta: {
      access: ['admin'],
      hideInMenu: false,
      title: '权限管理',
      notCache: true,
      icon: 'ios-infinite'
    },
    children: [
      {
        path: '/permission',
        name: 'permission',
        meta: {
          access: ['admin'],
          hideInMenu: false,
          title: '权限管理',
          notCache: true,
          icon: 'ios-infinite'
        },
        component: () => import('@/view/permission/permission')
      }
    ]
  },
  {
    path: '/',
    name: '_customer',
    component: Main,
    meta: {
      access: ['admin', 'Store Manager', 'sales'],
      hideInMenu: false,
      title: '客户管理',
      notCache: true,
      icon: 'md-arrow-dropdown-circle'
    },
    children: [
      {
        path: '/customer',
        name: 'customer',
        meta: {
          access: ['admin', 'Store Manager', 'sales'],
          hideInMenu: false,
          title: '客户管理',
          notCache: true,
          icon: 'md-arrow-dropdown-circle'
        },
        component: () => import('@/view/customer/customer')
      }
    ]
  },
  // {
  //   path: '/',
  //   name: '_customer_user',
  //   component: Main,
  //   meta: {
  //     access: ['admin', 'Store Manager', 'sales'],
  //     hideInMenu: false,
  //     title: '客户用户',
  //     notCache: true,
  //     icon: 'md-arrow-dropdown-circle'
  //   },
  //   children: [
  //     {
  //       path: 'customer_user',
  //       name: 'customer_user',
  //       meta: {
  //         access: ['admin', 'Store Manager', 'sales'],
  //         hideInMenu: false,
  //         title: '客户用户',
  //         notCache: true,
  //         icon: 'md-arrow-dropdown-circle'
  //       },
  //       component: () => import('@/view/customer/customer_user')
  //     }
  //   ]
  // },
  {
    path: '/',
    name: '_factory',
    component: Main,
    meta: {
      access: ['admin', 'Store Manager'],
      hideInMenu: false,
      title: '门店管理',
      notCache: true,
      icon: 'md-list'
    },
    children: [
      {
        path: '/factory',
        name: 'factory',
        meta: {
          access: ['admin', 'Store Manager'],
          hideInMenu: false,
          title: '门店管理',
          notCache: true,
          icon: 'md-list'
        },
        component: () => import('@/view/factory/factory')
      }
    ]
  },
  {
    path: '/',
    name: '_device',
    component: Main,
    meta: {
      access: ['admin', 'Store Manager', 'customer'],
      hideInMenu: false,
      title: '设备管理',
      notCache: true,
      icon: 'md-crop'
    },
    children: [
      {
        path: '/device_list',
        name: 'device_list',
        meta: {
          access: ['admin', 'Store Manager', 'customer'],
          hideInMenu: false,
          title: '设备列表',
          notCache: true,
          icon: 'md-list'
        },
        component: () => import('@/view/strategy_org/server_list')
      },
      {
        path: '/device_setting',
        name: 'device_setting',
        meta: {
          hideInMenu: true,
          title: '设备设置',
          access: ['admin', 'customer']
        },
        component: () => import('@/view/strategy_org/device_setting')
      },
      {
        path: '/inspection_info',
        name: 'inspection_info',
        meta: {
          hideInMenu: true,
          title: '验布信息',
          access: ['admin', 'customer']
        },
        component: () => import('@/view/strategy_org/inspection_info')
      },
      {
        path: '/running_logs',
        name: 'running_logs',
        meta: {
          hideInMenu: true,
          title: '运行日志',
          access: ['admin', 'customer']
        },
        component: () => import('@/view/strategy_org/running_logs.vue')
      }
    ]
  },
  {
    path: '/',
    name: '_order',
    component: Main,
    meta: {
      access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager'],
      hideInMenu: false,
      title: '订单管理',
      notCache: true,
      icon: 'md-trending-up'
    },
    children: [
      {
        path: 'order',
        name: 'order',
        meta: {
          access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager'],
          hideInMenu: false,
          title: '订单管理',
          notCache: true,
          icon: 'md-trending-up'
        },
        component: () => import('@/view/order/order')
      }
    ]
  },
  {
    path: '/',
    name: '_batch',
    component: Main,
    meta: {
      hideInMenu: true,
      title: '染缸管理',
      access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager']
    },
    children: [
      {
        path: 'batch',
        name: 'batch',
        meta: {
          hideInMenu: true,
          title: '染缸管理',
          notCache: true,
          icon: 'md-home',
          access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager']
        },
        component: () => import('@/view/order/batch')
      }
    ]
  },
  {
    path: '/',
    name: '_letter',
    component: Main,
    meta: {
      access: ['admin', 'Operation Management'],
      hideInMenu: true,
      title: '私信记录',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'letter',
        name: 'letter',
        meta: {
          access: ['admin', 'Operation Management'],
          hideInMenu: true,
          title: '私信记录',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/strategy_result/letter')
      }
    ]
  },
  {
    path: '/',
    name: '_flower',
    component: Main,
    meta: {
      access: ['admin', 'Operation Management'],
      hideInMenu: true,
      title: '关注的账号',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'flower',
        name: 'flower',
        meta: {
          access: ['admin', 'Operation Management'],
          hideInMenu: true,
          title: '关注的账号',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/strategy_result/flower')
      }
    ]
  }, 
  {
    path: '/',
    name: 'children_comment',
    component: Main,
    meta: {
      access: ['admin', 'Operation Management'],
      hideInMenu: true,
      title: '评论得子信息',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'children_comment',
        name: 'children_comment',
        meta: {
          access: ['admin', 'Operation Management'],
          hideInMenu: true,
          title: '评论得子信息',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/strategy_result/childrenComment')
      }
    ]
  },
  {
    path: '/',
    name: 'translate_check',
    component: Main,
    meta: {
      access: ['admin', 'operate video', 'video manager'],
      hideInMenu: true,
      title: '翻译编辑详情',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'translate_check',
        name: 'translate_check',
        meta: {
          access: ['admin', 'operate video', 'video manager'],
          hideInMenu: true,
          title: '翻译编辑详情',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/audio_video_manage/translate_check_form')
      }
    ]
  },
  {
    path: '/',
    name: 'check_srt_form',
    component: Main,
    meta: {
      access: ['admin', 'operate video before', 'video manager'],
      hideInMenu: true,
      title: '话术编辑',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'check_srt_form',
        name: 'check_srt_form',
        meta: {
          access: ['admin', 'operate video before', 'video manager'],
          hideInMenu: true,
          title: '话术编辑',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/audio_video_manage/check_srt_form')
      }
    ]
  },
  {
    path: '/',
    name: 'cover_audio_form',
    component: Main,
    meta: {
      access: ['admin',  'operate video', 'video manager'],
      hideInMenu: true,
      title: '语音转换',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'cover_audio_form',
        name: 'cover_audio_form',
        meta: {
          access: ['admin',  'operate video', 'video manager'],
          hideInMenu: true,
          title: '语音转换',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/audio_video_manage/covert_audio_check_form')
      }
    ]
  },  {
    path: '/',
    name: 'make_video_detail',
    component: Main,
    meta: {
      access: ['admin',  'operate video', 'video manager'],
      hideInMenu: true,
      title: '生成视频详情',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'make_video_detail',
        name: 'make_video_detail',
        meta: {
          access: ['admin',  'operate video', 'video manager'],
          hideInMenu: true,
          title: '语音转换',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/audio_video_manage/make_video_detail_form')
      }
    ]
  },
  {
    path: '/',
    name: 'stand_user',
    component: Main,
    meta: {
      access: ['admin', 'Operation Management', 'operate video before', 'video manager'],
      hideInMenu: true,
      title: '对标账号',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'stand_user',
        name: 'stand_user',
        meta: {
          access: ['admin', 'Operation Management', 'operate video before', 'video manager'],
          hideInMenu: true,
          title: '对标账号',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/strategy_result/stand_user_list')
      }
    ]
  },
  {
    path: '/',
    name: 'userFaceLibrary',
    component: Main,
    meta: {
      access: ['admin', 'Operation Management', 'operate video before', 'video manager'],
      hideInMenu: true,
      title: '人脸库',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'userFaceLibrary',
        name: 'userFaceLibrary',
        meta: {
          access: ['admin', 'Operation Management', 'operate video before', 'video manager'],
          hideInMenu: true,
          title: '人脸库',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/strategy_result/userFaceLibraryList')
      }
    ]
  },
  {
    path: '/',
    name: '_piece',
    component: Main,
    meta: {
      access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager'],
      hideInMenu: true,
      title: '布匹管理',
      notCache: true,
      icon: 'md-home'
    },
    children: [
      {
        path: 'piece',
        name: 'piece',
        meta: {
          access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager'],
          hideInMenu: true,
          title: '布匹管理',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/order/piece')
      }
    ]
  },
  {
    path: '/',
    name: '_remark',
    component: Main,
    meta: {
      access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager'],
      hideInMenu: true,
      title: '备注管理',
      notCache: true,
      icon: 'ios-infinite'
    },
    children: [
      {
        path: '/remark',
        name: 'remark',
        meta: {
          access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager'],
          hideInMenu: true,
          title: '备注管理',
          notCache: true,
          icon: 'ios-infinite'
        },
        component: () => import('@/view/remark/remark')
      }
    ]
  },
  {
    path: '/',
    name: '_finance',
    component: Main,
    meta: {
      access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager'],
        hideInMenu: false,
        title: '财务管理',
        notCache: true,
        icon: 'md-crop'
      },
    children: [
      {
        path: '/finance',
        name: 'finance',
        meta: {
        access: ['admin', 'Store Manager', 'sales', 'Warehouse Manager'],
          hideInMenu: false,
          title: '财务管理',
          notCache: true,
          icon: 'md-crop'
        },
        component: () => import('@/view/finance/finance')
      }
    ]
  }, 
   {
    path: '/',
    name: 'dy',
    component: Main,
    meta: {
      icon: 'md-menu',
      title: '运营后台',
      access: ['admin', 'operate video before', 'Operation Management', 'operate video', 'video manager', 'customer']
    },
    children: [
      {
        path: '/org_confg',
        name: 'org_confg',
        redirect: '/org_confg/server_list',
        meta: {
          icon: 'md-funnel',
          showAlways: true,
          hideInMenu:false,
          title: '基础配置',
          access: ['admin','Operation Management', 'operate video before', 'video manager', 'customer']
        },
        component: parentView,
        children: [
          {
            access: ['admin'],
            path: 'soft_version_list',
            name: 'soft_version_list',
            meta: {
              icon: 'md-funnel',
              title: '软件版本',
              access: ['admin']
            },
            component: () => import('@/view/strategy_org/soft_version_list')
          },  
          {
            access: ['admin'],
            path: 'model_management',
            name: 'model_management',
            meta: {
              icon: 'md-funnel',
              title: '模型管理',
              access: ['admin']
            },
            component: () => import('@/view/strategy_org/model_management')
          },
          {
            path: 'server_list',
            name: 'server_list',
            meta: {
              icon: 'md-funnel',
              title: '设备列表',
              access: ['admin', 'customer']
            },
            component: () => import('@/view/strategy_org/server_list')
          },          
          {
            access: ['admin'],
            path: 'mouth_gpt_modal',
            name: 'mouth_gpt_modal',
            meta: {
              icon: 'md-funnel',
              title: '口播gpt模版',
              access: ['admin']
            },
            component: () => import('@/view/strategy_org/mouth_gpt_modal')
          },
          {
            access: ['admin'],
            path: 'cookie_list',
            name: 'cookie_list',
            meta: {
              icon: 'md-funnel',
              title: 'cookie管理',
              access: ['admin']
            },
            component: () => import('@/view/strategy_org/cookies_list')
          },
          {
            path: 'classify_library',
            name: 'classify_library',
            meta: {
              icon: 'md-funnel',
              title: '分类库',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_org/classify_library')
          },
          {
            access: ['admin'],
            path: 'task_type_library',
            name: 'task_type_library',
            meta: {
              icon: 'md-funnel',
              title: '任务类型库',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_org/task_type_library')
          },
          {
            access: ['admin'],
            path: 'action_type_library',
            name: 'action_type_library',
            meta: {
              icon: 'md-funnel',
              title: '动作类型库',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_org/action_type_library')
          },
          {
            access: ['admin'],
            path: 'work_type_library',
            name: 'work_type_library',
            meta: {
              icon: 'md-funnel',
              title: '工作类型库',
              access: ['admin']
            },
            component: () => import('@/view/strategy_org/work_type_library')
          },
          {
            access: ['admin'],
            path: 'video_type_library',
            name: 'video_type_library',
            meta: {
              icon: 'md-funnel',
              title: '视频分类库',
              access: ['admin', 'Operation Management', 'operate video before', 'video manager']
            },
            component: () => import('@/view/strategy_org/video_type_library')
          }, {
            access: ['admin'],
            path: 'hashtag',
            name: 'hashtag',
            meta: {
              icon: 'md-funnel',
              title: 'hashtag',
              access: ['admin', 'Operation Management', 'operate video before', 'video manager']
            },
            component: () => import('@/view/strategy_org/hashtag_list')
          },
          // {
          //   path: 'scene_library',
          //   name: 'scene_library',
          //   meta: {
          //     icon: 'md-funnel',
          //     title: '剧情场景库',
          //     access: ['admin', 'Operation Management', 'operate video before', 'video manager']
          //   },
          //   component: () => import('@/view/strategy_org/scene_library')
          // },
          {
            access: ['admin'],
            path: 'gz_video_library',
            name: 'gz_video_library',
            meta: {
              icon: 'md-funnel',
              title: '钩子视频库',
              access: ['admin', 'Operation Management', 'operate video before', 'video manager']
            },
            component: () => import('@/view/strategy_org/gz_video_library')
          },
          {
            access: ['admin'],
            path: 'advertisement_video_library',
            name: 'advertisement_video_library',
            meta: {
              icon: 'md-funnel',
              title: '广告视频库',
              access: ['admin', 'Operation Management', 'operate video before', 'video manager']
            },
            component: () => import('@/view/strategy_org/advertisement_video_library')
          },
          {
            access: ['admin'],
            path: 'hj_video_library',
            name: 'hj_video_library',
            meta: {
              icon: 'md-funnel',
              title: '混剪视频库',
              access: ['admin', 'Operation Management', 'operate video before', 'video manager']
            },
            component: () => import('@/view/strategy_org/hj_video_library')
          },
          {
            access: ['admin'],
            path: 'mouth_video_library',
            name: 'mouth_video_library',
            meta: {
              icon: 'md-funnel',
              title: '嘴型视频库',
              access: ['admin', 'Operation Management', 'operate video before', 'video manager']
            },
            component: () => import('@/view/strategy_org/mouth_video_library')
          },
          {
            access: ['admin'],
            path: 'music_library_classify',
            name: 'music_library_classify',
            meta: {
              icon: 'md-funnel',
              title: '音乐类型',
              access: ['admin', 'Operation Management', 'operate video before', 'video manager']
            },
            component: () => import('@/view/strategy_org/music_library_classify')
          },
          {
            access: ['admin'],
            path: 'music_library',
            name: 'music_library',
            meta: {
              icon: 'md-funnel',
              title: '背景音频库',
              access: ['admin', 'Operation Management', 'operate video before', 'video manager']
            },
            component: () => import('@/view/strategy_org/music_library')
          },
          {
            path: 'device_logs',
            name: 'device-logs',
            meta: {
              hideInMenu: true,
              title: '设备日志',
              access: ['admin']
            },
            component: () => import('@/view/strategy_org/device_logs.vue')
          },
          {
            path: 'running_logs',
            name: 'running-logs',
            meta: {
              hideInMenu: true,
              title: '运行日志',
              access: ['admin', 'customer']
            },
            component: () => import('@/view/strategy_org/running_logs.vue')
          },
          {
            path: 'device_setting',
            name: 'device_setting',
            meta: {
              hideInMenu: true,
              title: '设备设置',
              access: ['admin', 'customer']
            },
            component: () => import('@/view/strategy_org/device_setting')
          },
          {
            path: 'inspection_info',
            name: 'inspection_info',
            meta: {
              hideInMenu: true,
              title: '验布信息',
              access: ['admin', 'customer']
            },
            component: () => import('@/view/strategy_org/inspection_info')
          }
        ]
      },
      {
        path: '/strategy',
        name: 'strategy',
        meta: {
          hideInMenu: false,
          title: '运营策略',
          icon: 'md-crop',
          access: ['admin', 'Operation Management']
        },
        component: parentView,
        children: [
          {
            path: 'gpt',
            name: 'gpt',
            meta: {
              icon: 'md-funnel',
              title: 'gpt',
              access: ['admin', 'Operation Management']
            },
          component: () => import('@/view/strategy_rule/gpt_classify')

          },
          {
            path: 'org',
            name: 'org',
            meta: {
              icon: 'md-funnel',
              title: '固定话术配置',
              access: ['admin', 'Operation Management']
            },
          component: () => import('@/view/strategy_rule/classify_org')

          },

          {
            path: 'advertisement',
            name: 'advertisement',
            meta: {
              icon: 'md-funnel',
              title: '广告语',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_rule/advertisement')
          },
          {
            path: 'tag',
            name: 'tag',
            meta: {
              icon: 'md-funnel',
              title: 'tag',
              access: ['admin', 'Operation Management']
            },
          component: () => import('@/view/strategy_rule/classify_tag')

          } ,
          {
            path: 'tag_stand',
            name: 'tag_stand',
            meta: {
              icon: 'md-funnel',
              title: '用户画像话术',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_rule/tag_stand')
          },
          {
            path: 'holiday_library',
            name: 'holiday_library',
            meta: {
              icon: 'md-funnel',
              title: '祝福语',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_rule/holiday_library')
          }
          ,
          {
            path: 'comment_strategy_rule',
            name: 'comment_strategy_rule',
            meta: {
              icon: 'md-funnel',
              title: '评论私信内容策略',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_rule/comment_strategy_rule')
          }
          ,          {
            path: 'comment_strategy',
            name: 'comment_strategy',
            meta: {
              icon: 'md-funnel',
              title: '评论要求关键字',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_rule/comment_strategy')
          },          {
            path: 'comment_strategy_keyword',
            name: 'comment_strategy_keyword',
            meta: {
              icon: 'md-funnel',
              title: '视频标题关键词',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_rule/comment_strategy_keyword')
          },
          // {
          //   path: 'letter_strategy',
          //   name: 'letter_strategy',
          //   meta: {
          //     icon: 'md-funnel',
          //     title: '私信周期策略'
          //   },
          //   component: () => import('@/view/strategy_rule/letter_strategy')
          // } ,
          {
            path: 'strategy_task',
            name: 'strategy_task',
            meta: {
              icon: 'md-funnel',
              title: '运营任务',
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_rule/strategy_task')
          }
        ]
      },
      {
        path: '/strategy_result',
        name: 'strategy_result',
        meta: {
          hideInMenu: false,
          title: '运营结果',
          icon: 'md-crop',
          access: ['admin', 'Operation Management',  'operate video before', 'operate video', 'video manager']
        },
        component: parentView,
        children: [
          {
            path: 'dy_user_list',
            name: 'dy_user_list',
            meta: {
              icon: 'md-funnel',
              title: '账号列表',
              hideInMenu: false,
              access: ['admin', 'Operation Management',  'operate video before', 'operate video', 'video manager'],
            },
            component: () => import('@/view/strategy_result/dy_user_list')

          }, 
          {
            path: 'stand_user_list',
            name: 'stand_user_list',
            meta: {
              icon: 'md-funnel',
              title: '对标账号',
              hideInMenu: false,
              access: ['admin', 'Operation Management',  'operate video before', 'operate video', 'video manager'],
            },
            component: () => import('@/view/strategy_result/stand_user_list')

          }, 
          {

            path: 'customer_classify_list',
            name: 'customer_classify_list',
            meta: {
              icon: 'md-funnel',
              title: '客户分类列表',
              hideInMenu: false,
              access: ['admin', 'Operation Management']
            },
          component: () => import('@/view/strategy_result/customer_classify_list')
          },          
          {
            path: 'strategy_result_list',
            name: 'strategy_result_list',
            meta: {
              icon: 'md-funnel',
              title: '评论记录',
              hideInMenu: false,
              access: ['admin', 'Operation Management']
            },
        component: () => import('@/view/strategy_result/strategy_result_list')

          },          
          {
            path: 'delete_comment_list',
            name: 'delete_comment_list',
            meta: {
              icon: 'md-funnel',
              title: '被删掉的评论记录',
              hideInMenu: false,
              access: ['admin', 'Operation Management']
            },
            component: () => import('@/view/strategy_result/comment_delete_list')

          }
        ]
      } ,
      {
        path: '/video_audio_manage',
        name: 'video_audio_manage',
        meta: {
          hideInMenu: false,
          title: '音视频管理',
          icon: 'md-crop',
          access: ['admin', 'operate video', 'operate video before', 'video manager']
        },
        component: parentView,
        children: [
          {
            path: 'start_video_task',
            name: 'start_video_task',
            meta: {
              icon: 'md-funnel',
              title: 'start_video_task',
              hideInMenu: false,
              access: ['admin',  'operate video before', 'video manager']
            },
            component: () => import('@/view/audio_video_manage/short_video_task_list')
          },
          {
            path: 'check_srt',
            name: 'check_srt',
            meta: {
              icon: 'md-funnel',
              title: 'check_srt',
              hideInMenu: false,
              access: ['admin',  'operate video before', 'video manager']
            },
            component: () => import('@/view/audio_video_manage/check_srt_list')
          },
          {
            path: 'translate_text',
            name: 'translate_text',
            meta: {
              icon: 'md-funnel',
              title: 'translate_text',
              hideInMenu: false,
              access: ['admin',  'operate video', 'video manager']
            },
            component: () => import('@/view/audio_video_manage/translate_text_list')
          },
          {
            path: 'char2Audio',
            name: 'char2Audio',
            meta: {
              access: ['admin',  'operate video', 'video manager'],
              icon: 'md-funnel',
              title: 'char2Audio',
              hideInMenu: false
            },
            component: () => import('@/view/audio_video_manage/char2audio_list')

          },
          {
            path: 'covert_face_list',
            name: 'covert_face_list',
            meta: {
              icon: 'md-funnel',
              title: 'covert_face_list',
              access: ['admin',  'operate video', 'video manager'],
              hideInMenu: false
            },
            component: () => import('@/view/audio_video_manage/covert_face_list')

          }, {
            path: 'merge_video',
            name: 'merge_video',
            meta: {
              icon: 'md-funnel',
              title: 'merge_video',
              access: ['admin',  'operate video', 'video manager'],
              hideInMenu: false
            },
          component: () => import('@/view/audio_video_manage/merge_video_list')
          }, 
          {
            path: 'advertisement_video',
            name: 'advertisement_video',
            meta: {
              icon: 'md-funnel',
              title: 'advertisement_video',
              access: ['admin',  'operate video', 'video manager'],
              hideInMenu: false
            },
          component: () => import('@/view/audio_video_manage/advertisement_video_list')
          }, 
          {
            path: 'push_video',
            name: 'push_video',
            meta: {
              icon: 'md-funnel',
              title: 'push_video',
              access: ['admin',  'operate video', 'video manager'],
              hideInMenu: false
            },
          component: () => import('@/view/audio_video_manage/push_video')
          }
          // , 
          // {
          //   path: 'video_data_views',
          //   name: 'video_data_views',
          //   meta: {
          //     icon: 'md-funnel',
          //     title: 'video_data_views',
          //     access: ['admin',  'operate video', 'video manager'],
          //     hideInMenu: false
          //   },
          // component: () => import('@/view/audio_video_manage/video_data_views')
          // }
        ]
      }
    ]
  },
  {
    path: '/argu',
    name: 'argu',
    meta: {
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'params/:id',
        name: 'params',
        meta: {
          icon: 'md-flower',
          title: route => `{{ params }}-${route.params.id}`,
          notCache: true,
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/argu-page/params.vue')
      },
      {
        path: 'query',
        name: 'query',
        meta: {
          icon: 'md-flower',
          title: route => `{{ query }}-${route.query.id}`,
          notCache: true
        },
        component: () => import('@/view/argu-page/query.vue')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
